let bundles = [];

function initBundles() {
  const bundle_elements = document.querySelectorAll("[data-bundle]");
  if (bundle_elements.length > 0) {
    bundle_elements.forEach((el) => {
      const bundle_name = el.dataset.bundle;
      if (bundle_name !== "") {
        if (!bundles.includes(bundle_name)) {
          bundles.push(bundle_name);
        }
      }
    });
    if (bundles.length > 0) {
      bundles.forEach((bundle) => {
        const bundle_type = document.querySelectorAll(
          `[data-bundle="${bundle}"]`
        );
        bundleMessage(bundle_type);
      });
    } else return;
  }
}

function bundleMessage(bundle_type) {
  if (bundle_type.length > 0) {
    const bundle_quantity = Number(bundle_type[0].dataset.bundle.split("|")[1]);
    const bundle_name = bundle_type[0].dataset.bundle.split("|")[0];
    const bundle_discount = bundle_type[0].dataset.bundle.split("|")[2];
    let quantity = 0;

    if (bundle_type.length > 1) {
      bundle_type.forEach((el) => {
        const quantity_input = el.querySelector(".js-quantity");
        quantity += Number(quantity_input.value);
      });
    } else {
      const quantity_input = bundle_type[0].querySelector(".js-quantity");
      quantity = Number(quantity_input.value);
    }

    const message =
      bundle_type[bundle_type.length - 1].querySelector(".message");
    if (quantity < bundle_quantity) {
      message.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-tag"><title>Label</title><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7" y2="7"></line></svg> <span> Add ${
        bundle_quantity - quantity
      } more ${bundle_name} and save ${bundle_discount}%</span>`;
    } else {
      message.innerHTML = "";
    }
  }
}

function customAddToCart(swat) {
  swat.evtLayer.addEventListener("sw:addedtocart", function (e) {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:cartchanged", {
        bubbles: true,
        cancelable: false,
      })
    );
  });
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(customAddToCart);

document.addEventListener("DOMContentLoaded", () => {
  initBundles();
});

document.addEventListener("theme:cartchanged", () => {
  setTimeout(() => {
    try {
      initBundles();
    } catch (e) {
      console.warn("⚠️ initBundles() failed:", e);
    }

    const params = new URLSearchParams(window.location.search);
    if (params.get("ref") === "quiz_rec") {
      const titleEl = document.querySelector(".product-form .title");
      const productTitle = titleEl ? titleEl.textContent.trim() : "Unknown";

      if (typeof gtag !== "undefined") {
        gtag("event", "quiz_recommended_add_to_cart", {
          quiz_type: "shade_finder",
          product_url: window.location.pathname,
          product_title: productTitle,
        });
        console.log("🛒 Sent quiz_recommended_add_to_cart to GA4");
      } else {
        console.warn("❌ gtag is not defined — GA4 not ready");
      }

      const url = new URL(window.location);
      url.searchParams.delete("ref");
      window.history.replaceState(
        {},
        document.title,
        url.pathname + url.search
      );
    }
  }, 1100);
});

let handles = [];
let products = [];
async function getProductsData() {
  const products_block = document.querySelectorAll(
    ".cart-drawer [data-product-handle]"
  );
  if (products_block.length > 0) {
    products_block.forEach((product_block) => {
      handles.push(product_block.dataset.productHandle);
    });

    for (const handle of handles) {
      const url = `${window.Shopify.routes.root}products/${handle}?view=get-product-json`;
      const response = await fetch(url);
      const result = await response.json();
      products.push(result);
    }
    return products;
  } else return;
}
function checkVariantAvailability() {
  products.forEach((product) => {
    const parent = document.querySelectorAll(
      `.cart-drawer .product-block[data-product-id="${product.id}"]`
    );
    parent.forEach((child) => {
      const addToCartButton = child.querySelector(
        ".js-add-to-cart-recommendations"
      );
      const firstAvailableVariantId = addToCartButton.dataset.firstAvailable;
      const colorOptions = child.querySelectorAll("[data-option-item]");
      colorOptions.forEach((option) => {
        const color = option.dataset.optionItem;
        const availableVariants = product.variants.filter(
          (variant) => variant.option1 === color && variant.available
        );
        if (availableVariants.length > 0) {
          option.classList.add("available");
        } else {
          option.classList.add("unavailable");
        }
      });

      const firstActiveChild = child.querySelector(
        "[data-option-item].available"
      );
      firstActiveChild.classList.add("active");

      const firstActiveChildOption = firstActiveChild.dataset.optionItem;
      const initialSize = product?.variants.filter(
        (variant) =>
          variant.option1 === firstActiveChildOption && variant.available
      );
      const sizeSelectors = child.querySelector(".js-option-size");
      if (sizeSelectors) {
        const options = sizeSelectors.querySelectorAll("option");
        options.forEach((option) => {
          const finded = initialSize.find(
            (size) => size.option2 === option.value
          );
          if (finded) {
            option.disabled = false;
          } else {
            option.disabled = true;
          }
        });
        const availableSize = sizeSelectors.querySelector(
          "option:not(:disabled)"
        );
        if (availableSize) {
          sizeSelectors.value = availableSize.value;
          initialVariant = product.variants.find(
            (variant) =>
              variant.option1 === firstActiveChildOption &&
              variant.option2 === sizeSelectors.value
          );
        } else {
          initialVariant = product.variants.find(
            (variant) => variant.option1 === firstActiveChildOption
          );
        }
      } else {
        initialVariant = product.variants.find(
          (variant) => variant.option1 === firstActiveChildOption
        );
      }
      if (initialVariant) {
        currentVariantId = initialVariant?.id;
      } else {
        currentVariantId = firstAvailableVariantId;
      }

      if (!currentVariantId) {
        addToCartButton.classList.add("button--sold-out");
        addToCartButton.innerHTML = addToCartButton.dataset.sold;
        addToCartButton.disabled = true;
      } else {
        addToCartButton.classList.remove("button--sold-out");
        addToCartButton.innerHTML = addToCartButton.dataset.add;
        addToCartButton.disabled = false;
      }
    });
  });
}

function initCartUpsell() {
  const upsellSection = document.querySelectorAll("[data-cart-upsell]");
  upsellSection.forEach((section) => {
    section.style.opacity = 0;
    section.style.visibility = "hidden";
    setTimeout(() => {
      section.style.display = "none";
    }, 800);
  });
  getProductsData().then((data) => {
    if (data) {
      upsellSection.forEach((section) => {
        section.style.opacity = 1;
        section.style.visibility = "visible";
        section.style.display = "block";
      });
      const products_block = document.querySelectorAll(
        ".cart-drawer [data-product-handle]"
      );
      products_block.forEach((product_block) => {
        let currentVariantId = "";
        let initialVariant = {};
        const product = products?.filter(
          (product) => product.id === Number(product_block.dataset.productId)
        )[0];
        const addToCartButton = product_block.querySelector(
          ".js-add-to-cart-recommendations"
        );
        const firstAvailableVariantId = addToCartButton.dataset.firstAvailable;
        const colorOptions =
          product_block.querySelectorAll("[data-option-item]");
        colorOptions.forEach((option) => {
          const color = option.dataset.optionItem;
          const availableVariants = product.variants.filter(
            (variant) => variant.option1 === color && variant.available
          );
          if (availableVariants.length > 0) {
            option.classList.add("available");
          } else {
            option.classList.add("unavailable");
          }
        });

        const firstActiveChild = product_block.querySelector(
          "[data-option-item].available"
        );
        firstActiveChild.classList.add("active");

        const firstActiveChildOption = firstActiveChild.dataset.optionItem;
        const initialSize = product?.variants.filter(
          (variant) =>
            variant.option1 === firstActiveChildOption && variant.available
        );
        const sizeSelectors = product_block.querySelector(".js-option-size");
        if (sizeSelectors) {
          const options = sizeSelectors.querySelectorAll("option");
          options.forEach((option) => {
            const finded = initialSize.find(
              (size) => size.option2 === option.value
            );
            if (finded) {
              option.disabled = false;
            } else {
              option.disabled = true;
            }
          });
          const availableSize = sizeSelectors.querySelector(
            "option:not(:disabled)"
          );
          if (availableSize) {
            sizeSelectors.value = availableSize.value;
            initialVariant = product.variants.find(
              (variant) =>
                variant.option1 === firstActiveChildOption &&
                variant.option2 === sizeSelectors.value
            );
          } else {
            initialVariant = product.variants.find(
              (variant) => variant.option1 === firstActiveChildOption
            );
          }
        } else {
          initialVariant = product.variants.find(
            (variant) => variant.option1 === firstActiveChildOption
          );
        }
        if (initialVariant) {
          currentVariantId = initialVariant?.id;
        } else {
          currentVariantId = firstAvailableVariantId;
        }

        if (!currentVariantId) {
          addToCartButton.classList.add("button--sold-out");
          addToCartButton.disabled = true;
        } else {
          addToCartButton.classList.remove("button--sold-out");
          addToCartButton.disabled = false;
        }

        document.addEventListener("option::change", (event) => {
          if (event) {
            let initialSize = [];
            const parentBlock = event.detail.element;
            const currentVariant = parentBlock.querySelector(
              ".product-block-options__item.active"
            );
            const curentColorOption = currentVariant?.dataset.optionItem;
            const currentProduct = products?.filter(
              (product) => product.id === Number(parentBlock.dataset.productId)
            );
            initialSize = currentProduct[0]?.variants?.filter(
              (variant) =>
                variant.option1 === curentColorOption && variant.available
            );

            const sizeSelectors = parentBlock.querySelector(".js-option-size");
            if (sizeSelectors) {
              const options = sizeSelectors.querySelectorAll("option");
              options.forEach((option) => {
                const finded = initialSize.find(
                  (size) => size.option2 === option.value
                );
                if (finded) {
                  option.disabled = false;
                } else {
                  option.disabled = true;
                }
              });
              const availableSize = sizeSelectors.querySelector(
                "option:not(:disabled)"
              );
              if (availableSize) {
                sizeSelectors.value = availableSize.value;
                initialVariant = currentProduct[0].variants?.find(
                  (variant) =>
                    variant.option1 === curentColorOption &&
                    variant.option2 === sizeSelectors.value
                );
              } else {
                initialVariant = currentProduct[0].variants?.find(
                  (variant) => variant.option1 === curentColorOption
                );
              }
            } else {
              initialVariant = currentProduct?.variants?.find(
                (variant) => variant.option1 === curentColorOption
              );
            }
            if (initialVariant) {
              currentVariantId = initialVariant?.id;
            }
          }
        });

        const sizeSelector = product_block.querySelector(".js-option-size");
        if (sizeSelector) {
          sizeSelector.addEventListener("input", () => {
            const currentVariant = product_block.querySelector(
              ".product-block-options__item.active"
            );
            const curentColorOption = currentVariant.dataset.optionItem;
            const currentSizeValue = sizeSelector.value;
            const currentProduct = products?.filter(
              (product) =>
                product.id === Number(product_block.dataset.productId)
            );
            initialVariant = currentProduct[0].variants.find(
              (variant) =>
                variant.option1 === curentColorOption &&
                variant.option2 === currentSizeValue
            );
            if (initialVariant) {
              currentVariantId = initialVariant?.id;
            }
          });
        }

        addToCartButton.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          addToCartButton.innerHTML =
            '<div class="loading-spinner loading-spinner--in-btn"></div>';
          const formData = {
            items: [
              {
                id: currentVariantId,
                quantity: 1,
              },
            ],
            sections: "cart-drawer",
          };
          fetch(theme.routes.cart_add_url, {
            body: JSON.stringify(formData),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
            },
          }).then((response) => {
            if (response.ok) {
              document.documentElement.dispatchEvent(
                new CustomEvent("theme:cartchanged", {
                  bubbles: true,
                  cancelable: false,
                  detail: { openDrawer: true },
                })
              );

              addToCartButton.innerHTML = "+";
            }
          });
        });
      });
    }
  });
}

document.addEventListener("cart::recommendations::perfomed", () => {
  initCartUpsell();
});

function removeNextDiv() {
  var swatchColorElements = document.querySelectorAll(
    ".collection-swatch-color"
  );
  swatchColorElements.forEach(function (swatchColorElement) {
    var nextElement = swatchColorElement.nextElementSibling;
    while (nextElement) {
      if (nextElement.tagName.toLowerCase() === "div") {
        nextElement.style.display = "none";
        break;
      }
      nextElement = nextElement.nextElementSibling;
    }
  });
}
function observeAndRemoveDivs() {
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        removeNextDiv();
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", function () {
  removeNextDiv();
  observeAndRemoveDivs();
});

function onQuickBuyContentLoad() {
  const quickBuyContent = document.querySelector(".quickbuy-content");
  if (quickBuyContent) {
    onclickRemove();
  } else {
    setTimeout(onQuickBuyContentLoad, 500);
  }
}

document.addEventListener("DOMContentLoaded", onQuickBuyContentLoad);

document.querySelectorAll(".quickbuy-toggle").forEach((button) => {
  button.addEventListener("click", function () {
    onQuickBuyContentLoad();
  });
});

function onclickRemove() {
  var swatchColorElements = document.querySelectorAll(
    ".quickbuy-content .swatch-colors"
  );
  swatchColorElements.forEach(function (swatchColorElement) {
    var nextElement = swatchColorElement.nextElementSibling;
    while (nextElement) {
      if (
        nextElement.tagName.toLowerCase() === "div" &&
        nextElement.querySelector(".option-selector--swatch")
      ) {
        nextElement.querySelector(".option-selector--swatch").style.display =
          "none";
        break;
      }
      nextElement = nextElement.nextElementSibling;
    }
    var activeSwatch = swatchColorElement.querySelector(
      ".swatch-options .swatch-color-option.active"
    );
    var optionLabel = swatchColorElement.querySelector(".option-label-text");

    if (activeSwatch) {
      var dataSwatchValue = activeSwatch.getAttribute("data-swatch");
      optionLabel.textContent = dataSwatchValue;
    }
  });
}
